import { Grid, Typography } from "@mui/material";

import { CallOffCodeChips } from "domains/partitions/components";
import localisations from "../../../localisation";

function ConfirmationStage(props: any) {
    const { 
        heading, 
        blurb,
        name,
        reference,
        ownerEmail,
        notes,
        callOfCodes } = localisations.editPartition.stages.confirmation;
    const fields = props.fields;
    
    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>
            <br />
            <Grid>
                <Typography>
                    {name}: {fields.name ?? null}
                </Typography>
                <Typography>
                    {reference}: {fields.reference ?? null}
                </Typography>
                <Typography>
                    {ownerEmail}: {fields.emailAddress ?? null}
                </Typography>
                <Typography>
                    {notes}: {fields.notes ?? null}
                </Typography>
                <br />
                <Grid container item xs={12}>
                    <CallOffCodeChips title={callOfCodes} deletable={false} callOffCodes={fields.callOffCodes}></CallOffCodeChips>
                </Grid>
            </Grid>
        </>
    );
}

export default ConfirmationStage;
